import { Checkbox } from "@/components/ui/checkbox";

const MODES = [
  ["replace", "Full replace", "Each row replaces the whole question and publishes it. Blank cells clear fields."],
  ["update", "Update selected fields", "Only the fields you tick change. Everything else on the question stays as it is."],
];

function Toggle({ id, checked, onChange, children }) {
  return (
    <label className="flex cursor-pointer items-start gap-2 text-sm text-foreground" htmlFor={id}>
      <Checkbox id={id} checked={checked} onCheckedChange={(v) => onChange(!!v)} className="mt-0.5" data-testid={id} />
      <span>{children}</span>
    </label>
  );
}

export function ImportOptions({ opts, setOpts, updatable }) {
  const set = (k) => (v) => setOpts((o) => ({ ...o, [k]: v }));
  const setMode = (mode) => setOpts((o) => ({ ...o, mode, unpublish_missing: mode === "replace" }));
  const toggleField = (f) => setOpts((o) => ({ ...o, fields: o.fields.includes(f) ? o.fields.filter((x) => x !== f) : [...o.fields, f] }));
  const update = opts.mode === "update";
  return (
    <div className="space-y-4 rounded-xl border border-border p-4" data-testid="sheet-options">
      <div className="grid gap-2 sm:grid-cols-2" role="radiogroup">
        {MODES.map(([key, label, help]) => (
          <button key={key} type="button" role="radio" aria-checked={opts.mode === key} onClick={() => setMode(key)} data-testid={`sheet-mode-${key}`}
            className={`rounded-xl border p-3 text-left transition-colors ${opts.mode === key ? "border-primary bg-primary/5" : "border-border hover:bg-muted/50"}`}>
            <p className="font-semibold text-foreground">{label}</p>
            <p className="mt-0.5 text-xs text-muted-foreground">{help}</p>
          </button>
        ))}
      </div>
      {update && (
        <div data-testid="sheet-fields">
          <div className="flex items-center justify-between">
            <p className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">Fields to update ({opts.fields.length} of {updatable.length})</p>
            <button type="button" className="text-xs font-semibold text-primary hover:underline" data-testid="sheet-fields-toggle-all"
              onClick={() => set("fields")(opts.fields.length === updatable.length ? [] : updatable)}>
              {opts.fields.length === updatable.length ? "Clear all" : "Select all"}
            </button>
          </div>
          {updatable.length === 0 && <p className="mt-2 text-sm text-destructive">No updatable columns found in this file.</p>}
          <div className="mt-2 grid gap-2 sm:grid-cols-3">
            {updatable.map((f) => (
              <Toggle key={f} id={`sheet-field-${f.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} checked={opts.fields.includes(f)} onChange={() => toggleField(f)}>{f}</Toggle>
            ))}
          </div>
        </div>
      )}
      <div className="space-y-2 border-t border-border pt-3">
        <Toggle id="sheet-opt-unpublish" checked={opts.unpublish_missing} onChange={set("unpublish_missing")}>
          Unpublish questions in these books that aren&apos;t in the file (they go to the Review queue)
        </Toggle>
        <Toggle id="sheet-opt-create" checked={opts.create_new} onChange={set("create_new")}>
          Create questions that are in the file but not on the site{update ? " (added as Drafts)" : " (published)"}, tagged &ldquo;Added by import&rdquo;
        </Toggle>
        {update && (
          <Toggle id="sheet-opt-blank" checked={opts.blank_clears} onChange={set("blank_clears")}>
            Blank cells clear the field (otherwise blank cells are skipped)
          </Toggle>
        )}
      </div>
    </div>
  );
}
